import Link from 'next/link';
import styles from './index.module.scss';

const Footer = () => {
  return (
    <footer className={styles.pageFooter} role="contentinfo">
      <div className={styles.legalLinkContainer}>
        <Link href="/privacypolicy">
          <a className={styles.legalLink}>Privacy Policy</a>
        </Link>
        &nbsp;|&nbsp;
        <Link href="/user-agreement">
          <a className={styles.legalLink}>User Agreement</a>
        </Link>
      </div>
    </footer>
  );
};

export default Footer;